import React from "react";
import SideBar from "../components/sidebar";
import Dropdowns from "../components/dropdowns";


const CompareLaptimes = ({ showSidebar, isPremium, setPage, page, figureImage, setFigureImage  }) => {
    return (
        <div className="laptimes-container">
            {showSidebar || <SideBar setPage={setPage}/>}

            <div className="laptimes-content">
                <div className="laptimes-header">
                    Welcome to the compare driver hub!
                </div>
                
                <div className="laptimes-dropdowns">
                    <Dropdowns
                    isPremium={isPremium}
                    page={page}
                    figureImage={figureImage}
                    setFigureImage={setFigureImage}
                    />
                </div>

                <div className="laptimes-output">
                    <ul className="output-list">
                        <li><img src={figureImage}/></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default CompareLaptimes; 